
import { FC, useCallback, useContext } from "react";
import DruidWebchatContext, { DruidWebchatContextType, WebChatHeaderOptions } from "../../WebChatContext";


import { useMergedOptions } from "../../selectors/useMergedOptions";
import * as bsIcons from 'react-icons/bs';
import IconButton from 'botframework-webchat-component/lib/SendBox/IconButton';
import classNames from "classnames";
import useDruidLocalize from "../../hooks/useDruidLocalize";



export const DruidReloadSelector: FC = () => {
  const [, druidWebChatDispatch, ,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

  const {
    styleOptions: { } = {},
    UI: { headerFontSize } = {},
    disabled,
  } = useMergedOptions();
  const druidLocalize = useDruidLocalize();

  const ReloadIcon = bsIcons["BsArrowRepeat"];


  const handleReload = useCallback((e) => {
    e.stopPropagation();

    druidWebChatDispatch({
      type: 'RESET',
      // payload: { // if payload is removed, possible bug fixes. safer to not set payload.
      //   UI: {
      //     autoExpandEnabled: true
      //   }
      // },
      withAutoExpand: true
    });
  }, [druidWebChatDispatch]);


  // !!!!! --- Stylings are defined in DruidHeader.tsx !!!!!!
  return (<IconButton
    alt={druidLocalize("DRUID_SETTINGS_RELOAD_BUTTON_ALT")}
    className={classNames('druid__webchat__header-button',  'druid__webchat__header-fadeIn','druid__webchat__header-reload')}
    disabled={disabled}
    onClick={handleReload}
  >
    <ReloadIcon size={headerFontSize!}></ReloadIcon>
  </IconButton>)

}




